import axios from 'axios';
import type {
  IUserGetOngoingTransferCountQuery,
  IUserGetOngoingTransferCountResponse,
} from '@/app-package';

const getOngoingTransferCount = async (
  params: IUserGetOngoingTransferCountQuery,
) => {
  const { data } = await axios.get<IUserGetOngoingTransferCountResponse>(
    'transfer/ongoing/count',
    { params },
  );

  return data;
};

export default getOngoingTransferCount;
